var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showMessageBox
    ? _c("div", { staticClass: "message-box-bg flex-center" }, [
        _c("div", { staticClass: "message-box" }, [
          _c("div", { staticClass: "message-box-main" }, [
            _c("div", { staticClass: "message-box-top" }, [
              _c("h4", { staticClass: "flex-center" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("home.walletConnect.messageBox.title")) +
                    " "
                ),
              ]),
              _c("i", {
                staticClass: "icon icon-close",
                on: { click: _vm.onShowMessageBox },
              }),
            ]),
            _c(
              "div",
              {
                staticClass: "box-but flex-align-center metamask-but",
                on: {
                  click: function ($event) {
                    return _vm.toConnectWallet("metamask")
                  },
                },
              },
              [
                _c("i", { staticClass: "icon icon-metamask" }),
                _c("h6", [_vm._v("MetaMask")]),
              ]
            ),
          ]),
          _c(
            "div",
            { staticClass: "message-box-bott" },
            [
              _vm.inviteAddress
                ? [
                    _c("p", { staticClass: "message-box-bott-addr" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$format.captureAddress(_vm.inviteAddress))
                        ),
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("common.connectWalletMessageBox.invitesText")
                          )
                        ),
                      ]),
                    ]),
                    _c("p", { staticClass: "text-min text-opacity" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "common.connectWalletMessageBox.onceConnectedText"
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]
                : [
                    _c("p", { staticClass: "message-box-bott-addr" }, [
                      _c(
                        "a",
                        {
                          staticClass: "a-link",
                          attrs: {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: _vm.aLink,
                          },
                        },
                        [_vm._v(_vm._s(_vm.aLink))]
                      ),
                    ]),
                    _c("p", { staticClass: "text-min text-opacity" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "common.connectWalletMessageBox.inviteFriendsText"
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ],
            ],
            2
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }